import { ReactElement, useState } from 'react'
import { makeStyles } from 'tss-react/mui'
import { Grid, Typography } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import DataTable from '@src/components/DataTable'
import { DataColumn } from '@src/components/DataTable/DataTable'
import {
  SemiConfigClone,
  useProductFromQueryParam,
  getProductBasedTableColumns,
  getProductBasedUniqueIdName,
} from '../../ProductsConfiguration'
import TableExpanded from './TableExpanded'

const useStyles = makeStyles()((theme) => ({
  container: {
    paddingTop: theme.spacing(8),
  },
  instructions: {
    padding: theme.spacing(8, 0),
    '& h6': {
      fontWeight: 700,
    },
  },
  table: {
    display: 'flex',
    '& th': {
      verticalAlign: 'middle',
    },
    '& .MuiTableCell-root': {
      padding: theme.spacing(2, 2),
    },
  },
}))
export interface DataCount {
  pageStart: number
  pageEnd: number
  totalCount: number
}
interface ClonesTableProps {
  tableTitle: ReactElement
  tableData: SemiConfigClone[]
  dataCount: DataCount
}

const ClonesTable = ({
  tableTitle,
  tableData,
  dataCount,
}: ClonesTableProps) => {
  const { classes } = useStyles()
  const product = useProductFromQueryParam()
  const uniqueIdName = getProductBasedUniqueIdName(product)
  const [expandedList, setExpandedList] = useState<string[]>([])

  const toggleDetail = (id: string) => {
    const updatedList = expandedList.includes(id)
      ? expandedList.filter((expanded) => expanded !== id)
      : [...expandedList, id]
    setExpandedList(updatedList)
  }
  const checkForExpanded = (id?: string) => {
    return !!(id && expandedList.includes(id))
  }

  const tableColumns: DataColumn<SemiConfigClone>[] =
    getProductBasedTableColumns({
      product: product,
      searchResults: tableData,
      checkForExpanded: checkForExpanded,
      toggleDetail: toggleDetail,
    })

  const noResultsComponent = (
    <FormattedMessage id="NO_RESULTS_FOUND" defaultMessage="No results found" />
  )
  const tableExpandedComponent = (data: SemiConfigClone) => {
    return expandedList.includes(data?.[uniqueIdName] || '') ? (
      <TableExpanded data={data.moreInformation} product={product} />
    ) : (
      <></>
    )
  }

  return (
    <Grid container className={classes.container}>
      <Grid item xs={12}>
        <Typography variant="h3">{tableTitle}</Typography>
      </Grid>
      <Grid item xs={12} className={classes.instructions}>
        <Typography variant="subtitle1">
          <FormattedMessage
            id="WEBINAR_PAGINATION"
            defaultMessage="Showing {pageStart} - {pageEnd} of {numberOfPages} Results"
            values={{
              pageStart: dataCount.pageStart,
              pageEnd: dataCount.pageEnd,
              numberOfPages: dataCount.totalCount,
            }}
          />
        </Typography>
      </Grid>
      <Grid item xs={12} className={classes.table}>
        <DataTable
          data={tableData}
          columns={tableColumns}
          noDataComponent={noResultsComponent}
          captionText={tableTitle}
          afterRow={tableExpandedComponent}
        />
      </Grid>
    </Grid>
  )
}

export default ClonesTable
